import React from "react";
import "react-router-dom";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
<footer className="footer">
  <div className="footer-container">

    {/* LEFT - COMPANY */}
    <div className="footer-col">
      <h2 className="footer-logo">
        Lifetime <span>Infotech</span>
      </h2>

      <p>
        Lifetimeinfotech is highly committed to deliver services
        that are excellent in quality & cost-effective. We strive to lead
        global IT market by powerful tech methodologies.
      </p>

      <div className="social-icons">
        <i className="bi bi-facebook"></i>
        <i className="bi bi-instagram"></i>
        <i className="bi bi-linkedin"></i>
        <i className="bi bi-twitter"></i>
      </div>
    </div>

    {/* CENTER - QUICK LINKS */}
    <div className="footer-col">
      <h3>Quick Links</h3>

      <ul className="footer-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/services">Services</Link></li>
        <li><Link to="/portfolio">Portfolio</Link></li>
        <li><Link to="/contact1">Contact Us</Link></li>
      </ul>
    </div>

    {/* RIGHT - CONTACT + ADDRESS */}
    <div className="footer-col">
      <h3>Reach Us</h3>

      <p>
        <i className="bi bi-geo-alt"></i>
        Shop No-09/GF,Triveni Appartment,CK Park,OPP.Laxmi Diamond,Surat-395008 Gujarat , India.
      </p>

      <h3 className="contact-heading">Contact</h3>

      <p>
        <i className="bi bi-telephone"></i> (+91) 99046 10846
      </p>

      <p>
        <i className="bi bi-envelope"></i> lifetimeinfotech@gmail.com
      </p>
<Link to="/contact1" className="contact-btn">
  <i className="bi bi-send"></i> Get in Touch
</Link>
      
    </div>

  </div>

  <div className="footer-bottom">
    © 2025 Lifetimeinfotech. All Rights Reserved
  </div>
</footer>
  );
};

export default Footer;